import React from 'react';
import UserBoardHeader from '@/userBoard/views/UserBoardHeader';
import FavoritesTabs from '@/favorites/components/FavoritesTabs';

export function FavoritesHeader({ active }) {
    return (
        <UserBoardHeader pageFixerClassName="tabs">
            <FavoritesTabs active={active} />
        </UserBoardHeader>
    );
}
